import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import { BellOutlined } from '@ant-design/icons';

// styled-components
import FlexMainWrapper from '../../designComponents/wrappers/FlexMainWrapper';
import { Image } from '../../designComponents/imageboxs/Image';
import { ItemButton } from '../../designComponents/buttons/Buttons';

import { errImage } from '../../utils/errImage';

// 최상단 헤더
const TopHeader = ({ logout, adminInfo }) => {
    const navigate = useNavigate();
    const [infoModal, setInfoModal] = useState(false);
    const [alarmModal, setAlarmModal] = useState(false);
    const ref = useRef(null);

    const handleClickOutside = (event) => {
        if (!ref.current) {
            return;
        }

        if (!ref.current.contains(event.target)) {
            setInfoModal(false);
            setAlarmModal(false);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <Header>
            <FlexMainWrapper style={{ alignItems: 'center', gap: '17px' }} />

            <FlexMainWrapper style={{ alignItems: 'center', gap: '30px', marginRight: '20px' }}>
                <FlexMainWrapper style={{ alignItems: 'center', gap: '15px' }}>
                    {adminInfo?.name && (
                        <div style={{ color: 'rgb(78, 89, 104)', fontSize: '13px' }}>
                            <span style={{ fontWeight: 600 }}>{adminInfo.name}</span>
                            <span style={{ marginLeft: '3px' }}>님 안녕하세요</span>
                        </div>
                    )}
                    <DropDownModal
                        onClick={() => {
                            setAlarmModal((prev) => !prev);
                            alert('현재 기능을 준비중입니다.');
                        }}
                        renderImage={<ItemButton iconStyle={{ fontSize: '25px', margin: '0 3px 0 3px' }} item={<BellOutlined />} alarm={false} />}
                        trigger={alarmModal}
                        modal={<div ref={ref}></div>}
                    />
                    <DropDownModal
                        onClick={() => setInfoModal((prev) => !prev)}
                        renderImage={<Image width={27} height={27} style={{ borderRadius: '50%' }} errImg={errImage({ sex: 1 })} />}
                        trigger={infoModal}
                        modal={
                            <div ref={ref}>
                                <ModalBox
                                    onClickMyInfo={() => {
                                        setInfoModal(false);
                                        navigate(`/myPage/${adminInfo.id}`);
                                    }}
                                    onClickAlert={() => alert('해당 기능은 아직 존재하지 않습니다.')}
                                    onClickLogout={() => {
                                        if (window.confirm('로그아웃을 진행하시겠습니까?')) {
                                            logout();
                                            navigate('/login');
                                        }
                                    }}
                                />
                            </div>
                        }
                    />
                </FlexMainWrapper>
            </FlexMainWrapper>
        </Header>
    );
};

export default TopHeader;

const DropDownModal = ({ onClick, renderImage, trigger, modal, modalStyle }) => {
    return (
        <ModalWrapper>
            <div style={{ cursor: 'pointer' }} onClick={onClick}>
                {renderImage}
            </div>
            {trigger && <ModalItem style={{ ...modalStyle }}>{modal}</ModalItem>}
        </ModalWrapper>
    );
};

const ModalBox = ({ myInfoText = '내 정보', leftText = '알람', onClickMyInfo, onClickAlert, onClickLogout }) => {
    return (
        <FlexMainWrapper style={{ flexDirection: 'column', width: '100%', gap: 0 }}>
            <MainHeaderActionButton text={myInfoText} onClick={onClickMyInfo} />
            <MainHeaderActionButton text={leftText} onClick={onClickAlert} />
            <MainHeaderActionButton onClick={onClickLogout} />
        </FlexMainWrapper>
    );
};

const MainHeaderActionButton = ({ fontStyle, text = '로그아웃', onClick }) => {
    return (
        <MainHeaderLogoutBtn style={{ ...fontStyle }} onClick={onClick}>
            {text}
        </MainHeaderLogoutBtn>
    );
};

const Header = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-height: 72px;
    padding: 0 20px;
    border-bottom: 1px solid #e9eaed;
    background-color: #ffffff;
`;

const ModalWrapper = styled.div`
    position: relative;
`;

const ModalItem = styled.div`
    z-index: 3;
    position: fixed;
    top: 72px;
    right: 20px;
    background-color: #fff;
    border-radius: 10px;
    box-shadow: 0.1px 1px 10px 0.1px #dcdee0;
    width: 200px;
`;

const MainHeaderLogoutBtn = styled.div`
    cursor: pointer;
    font-size: 12px;
    font-family: noto_sans_kr_regular;
    text-align: center;
    width: 80px;
    margin: 5px;
    padding: 10px 50px;
    border-radius: 10px;

    :hover {
        background-color: #f2f4f6;
    }
`;
